<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增抵押周期设置"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="借贷币种：" prop="borrowCoinType">
          <el-select v-model="val.borrowCoinType">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期：" prop="numberDays">
          <el-input-number v-model="val.numberDays" :min="7"></el-input-number>
          注：周期最小为7天
        </el-form-item>
        <el-form-item label="年化利率：" prop="rate">
          <el-input-number
            v-model="val.rate"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="违约费率：" prop="defaultRate">
          <el-input-number
            v-model="val.defaultRate"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-input-number>
          注：提前还款时，一次性收取的费用和借贷金额的比例
        </el-form-item>
        <el-form-item label="逾期费率：" prop="overdueRate">
          <el-input-number
            v-model="val.overdueRate"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-input-number>
          注：逾期还款时，每日收取的费用和借贷金额的比例
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'cycleCreate',
  data() {
    return {
      dialogVisible: false,
      val: {},
      rules: {
        borrowCoinType: {
          required: true,
          message: '请填写'
        },
        numberDays: {
          required: true,
          message: '请填写'
        },
        rate: {
          required: true,
          message: '请填写'
        },
        defaultRate: {
          required: true,
          message: '请填写'
        },
        overdueRate: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {},
  computed: {
    ...mapState('cycle', ['coinTypeList'])
  },
  methods: {
    ...mapActions('cycle', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create({ ...this.val }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less"></style>
